import { useAvailableCallerIds } from '@/api/agents'
import { readSessionCallerId } from '@/lib/sessionCallerId'

/**
 * Source de vérité unique pour le numéro sortant à utiliser comme caller ID.
 *
 * Priorité :
 *   1. Numéro choisi par l'agent (sessionStorage), s'il est bien une ligne de
 *      l'entreprise : une ligne d'un autre compte est oubliée
 *   2. Numéro principal de la company (assignment_type === 'main')
 *   3. Premier numéro disponible
 *
 * Sans caller ID valide, le webhook backend `twilio_voice_web_outbound`
 * fallback sur le 1er PhoneNumber de la company. Mais si la company n'a
 * aucun numéro avec un `number_sid` Twilio, le TwiML `<Dial>` part sans
 * `callerId` → erreur Twilio 13214. Passer explicitement le caller_id
 * permet aussi à l'agent de choisir parmi ses numéros.
 */
export function useSelectedCallerId(): string | null {
  const { data: availableCallerIds } = useAvailableCallerIds()

  if (typeof window === 'undefined' || !availableCallerIds) return null

  const fromSession = readSessionCallerId(availableCallerIds)
  if (fromSession) return fromSession

  const main = availableCallerIds.find((n) => n.assignment_type === 'main')
  if (main?.phone_number) return main.phone_number

  return availableCallerIds[0]?.phone_number ?? null
}
